import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ProjectPage from '../../components/ProjectPage'

const projectElements = {
	images: [
	  {
	    "src": "Schulportrait/school_1",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Schulportrait/school_2",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Schulportrait/school_3",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Schulportrait/school_4",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Schulportrait/school_5",
	    "orientation": "portrait"
	  }
	]
}

export default class Schulportrait extends React.Component{
	render(){
		return(
			<ProjectPage 
			title="Schulportrait" 
			text="Diese Fotoserie zeigt eine Auswahl unterschiedlicher Klassensessel. Ich habe mich entschieden diese wie 
			Schüler-Portraits zu fotografieren, um den Aspekt des Schulportraits hervorzuheben." 
			images={projectElements.images}/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/projects/school.js